// extracted by mini-css-extract-plugin
module.exports = {"link":"TextIconLink_link__y5D9r","circleArrowIconBlack":"TextIconLink_circleArrowIconBlack__3AUCV","circleArrowIconWhite":"TextIconLink_circleArrowIconWhite__u__vf"};